import React from 'react';

import ProcurementPlanChart from '../../procurement_plan/ProcurementPlanChart';
import { useProcurement } from '../context/ProcurementContext';

const ProcurementGanttChartTab = () => {
    const { routes } = useProcurement();

    return <ProcurementPlanChart fetchUrl={routes.fetchProcurementPlanUrl} />;
};

export default ProcurementGanttChartTab;
